// eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-ignore twin.macro doit être importé pour que les props `tw="..."` soient transformées par babel-plugin-macros
import tw from "twin.macro";
import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Message "arrêt d'urgence actif → contactez le support", partagé entre le
 * sheet dédié (emergency-stop), action-in-progress et action-launcher.
 */
function EmergencyStopSupportMessage() {
  const { t: translator } = useTranslation();

  return (
    <div tw="flex flex-col items-center gap-4 rounded-2xl border border-red-100 bg-gradient-to-b from-red-50 to-white px-5 py-7 text-center">
      {/* Badge : icône dans un cercle rouge + halo pulsant. */}
      <div tw="relative flex items-center justify-center">
        <span tw="absolute inline-flex h-16 w-16 rounded-full bg-red-400 opacity-30 animate-ping" />
        <div tw="relative flex h-16 w-16 items-center justify-center rounded-full bg-modules-redBase text-white shadow-lg shadow-red-500/30">
          <ShieldAlert tw="h-8 w-8" />
        </div>
      </div>

      <h3 tw="text-lg font-semibold text-gray-900">
        {translator("action.emergencyStopActiveTitle")}
      </h3>
      <p tw="max-w-xs text-sm leading-relaxed text-gray-500">
        {translator("action.emergencyStopSupport")}
      </p>
    </div>
  );
}

export default EmergencyStopSupportMessage;
